






















import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import "swiper/css/swiper.css";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
@Component({
  components: {
    Swiper,
    SwiperSlide
  }
})
export default class Index extends Vue {
  SwiperNew = {
    direction: "vertical",
    observer: true, //修改swiper自己或子元素时，自动初始化swiper
    observeParents: true, //修改swiper的父元素时，自动初始化swiper
    loop: true, // 循环
    autoplay: {
      delay: 2000,
      disableOnInteraction: false
    },
    slidesPerView: 7, // 每页显示几个slide
    speed: 600 // 速度
  };
  @Prop()
  list!: [];
  @Prop()
  jump!: [];
  on_top_enter() {
    (this.$refs.mySwiper as any).$swiper.autoplay.stop();
  }
  on_top_leave() {
    (this.$refs.mySwiper as any).$swiper.autoplay.start();
  }
}
